module.exports = __webpack_public_path__ + "img/marketing_fr.8904accf.png";